import { useState, Fragment } from "react";
import { Tooltip, List, ListItem, ListItemText, Divider, Typography, IconButton, Box, Collapse } from "@material-ui/core";
import LocalAirportIcon from "@material-ui/icons/LocalAirport";
import AirportShuttleIcon from "@material-ui/icons/AirportShuttle";
import WeekendIcon from "@material-ui/icons/Weekend";
import MuseumIcon from "@material-ui/icons/Museum";
import HotelIcon from "@material-ui/icons/Hotel";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import ButtonEdit from "../../../global/ButtonEdit";
import PhotoLibraryIcon from "@material-ui/icons/PhotoLibrary";
import DeckIcon from "@material-ui/icons/Deck";
import LabelDestinos from "./../LabelDestinos";
import LabelTipoPaquete from "./labelTipoPaquete";
import { formatDinero } from "./../../../utils/formatDinero";
import { TPaquetesStyle } from "./styles";
import FPaqueteDetalle from "../FPaqueteDetalle/indes";
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { makeStyles } from '@material-ui/core/styles';
import LabelEstatusPaquete from "./LabelEstatusPaquete";
import FormularioEstatusPaquete from "./FormularioEstatusPaquete";
import SwitchAdministracion from "./SwitchAdministracion";
import LabelAdministrado from "./LabelAdministrado";
import SwitchTipoViaje from "./SwitchTipoViaje";
import { useDispatch } from "react-redux";
import FindInPageIcon from '@material-ui/icons/FindInPage';
import { openModalLandingPaqueteAction } from "../../../ducks/landingDuck";
const columns = [
  { id: "Accion", minWidth: 10, align: "center", label: "" },
  {
    id: "FolioPaquete",
    minWidth: 50,
    align: "center",
    label: "Folio",
  },
  {
    id: "Nombrepaquete",
    minWidth: 150,
    align: "center",
    label: "Nombre paquete",
  },
  { id: "Origen", minWidth: 50, align: "center", label: "Origen / Destinos" },
  { id: "Precio", minWidth: 80, align: "center", label: "Precio" },
  { id: "TipoPaquete", minWidth: 30, align: "center", label: "Tipo paquete" },
  { id: "Estatus", minWidth: 10, align: "center", label: "Tipo viaje" },
  { id: "Estatus", minWidth: 10, align: "center", label: "Estatus" },

];

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },

});

function Row(props) {
  const {
    row,
    onEditar = () => { },
    onVuelos = () => { },
    onExtras = () => { },
    onHotel = () => { },
    onHabitacion = () => { },
    onSalidas = () => { },
    onGaleria = () => { },
    onDestinos = () => { },
  } = props
  
  const [open, setOpen] = useState(false)
  const classes = useRowStyles()
  const dispatch = useDispatch()
  const openModalLadingPaquete = (row) => {
    dispatch(openModalLandingPaqueteAction({clavePaquete: row?.ClavePaquete}))
  }
  return (
    <Fragment>
      <TableRow className={classes.root} hover>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell align="center">{row.FolioPaquete}</TableCell>
        <TableCell align="center">{row.Nombre}</TableCell>
        <TableCell align="center">
          <div className={classes.section1}>
            <Typography gutterBottom variant="body2" align="center">
              {row.Origen && (
                <p>{`${row.Origen.Pais.Nombre} - ${row.Origen.Nombre} `}</p>
              )}
            </Typography>
          </div>
          <Divider variant="middle" />
          <div className={classes.section2}>
            <LabelDestinos Destinos={row.Destinos} />
          </div>
        </TableCell>
        <TableCell align="center">
          <List className={classes.root}>
            <ListItem>
              <ListItemText
                primary="Neto"
                secondary={`${formatDinero(row.PrecioNeto)} ${row.Moneda.Clave
                  }`}
              />
            </ListItem>
            <Divider component="li" />
            <ListItem>
              <ListItemText
                primary="Publico"
                secondary={`${formatDinero(row.PrecioPublico)} ${row.Moneda.Clave
                  }`}
              />
            </ListItem>
          </List>
        </TableCell>
        <TableCell align="center">
          <LabelTipoPaquete arrayData={row.TipoPaquete} />
        </TableCell>
        <TableCell align="center">
          {(row.Internacional) ? 'Internacional' : 'Nacional' }
        </TableCell>
        <TableCell align="center">
          <LabelEstatusPaquete
            Estatus={row.paqueteEstatus?.EstatusPaquete?.IdCatEstatusPaquete}
            Descipcion={row.paqueteEstatus?.EstatusPaquete?.Descripcion}
          />
          <LabelAdministrado
            Estatus={row.paqueteEstatus?.AdministradoDooddo}
          />
        </TableCell>

      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Acción
              </Typography>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                  <ButtonEdit
                    onClick={() => {
                      onEditar(row);
                    }}
                  />
                  <FPaqueteDetalle row={row} />
                  <Tooltip title="Destinos">
                    <IconButton
                      aria-label="Destinos"
                      onClick={() => {
                        onDestinos(row);
                      }}
                    >
                      <DeckIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Vuelos">
                    <IconButton
                      aria-label="Vuelos"
                      onClick={() => {
                        onVuelos(row);
                      }}
                    >
                      <LocalAirportIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Hotel">
                    <IconButton
                      aria-label="Hotel"
                      onClick={() => {
                        onHotel(row);
                      }}
                    >
                      <WeekendIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Habitaciones">
                    <IconButton
                      aria-label="Habitaciones"
                      onClick={() => {
                        onHabitacion(row);
                      }}
                    >
                      <HotelIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Extras">
                    <IconButton
                      aria-label="Extras"
                      onClick={() => {
                        onExtras(row);
                      }}
                    >
                      <MuseumIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Salidas">
                    <IconButton
                      aria-label="Salidas"
                      onClick={() => {
                        onSalidas(row);
                      }}
                    >
                      <AirportShuttleIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Galeria">
                    <IconButton
                      aria-label="Galeria"
                      onClick={() => {
                        onGaleria(row);
                      }}
                    >
                      <PhotoLibraryIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Lading">
                    <IconButton
                      aria-label="Lading"
                      onClick={() => openModalLadingPaquete(row)}
                    >
                      <FindInPageIcon />
                    </IconButton>
                  </Tooltip>
                </div>
                <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "1rem" }}>
                  <FormularioEstatusPaquete
                    clavePaquete={row.ClavePaquete}
                    idEstatusPaquete={row.paqueteEstatus?.EstatusPaquete?.IdCatEstatusPaquete}
                    AdministradoDooddo={row.paqueteEstatus?.AdministradoDooddo}
                  />
                  <SwitchAdministracion
                    clavePaquete={row.ClavePaquete}
                    idEstatusPaquete={row.paqueteEstatus?.EstatusPaquete?.IdCatEstatusPaquete}
                    AdministradoDooddo={row.paqueteEstatus?.AdministradoDooddo}
                  />
                  <SwitchTipoViaje
                   IdPaquete={row?.IdPaquete}
                   EsInternacional={row?.Internacional}
                  />
                </div>
              </div>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </Fragment>
  );
}

export default function TPaquetes(props) {
  const {
    rows = [],
    onEditar = () => { },
    onVuelos = () => { },
    onExtras = () => { },
    onHotel = () => { },
    onHabitacion = () => { },
    onSalidas = () => { },
    onGaleria = () => { },
    onDestinos = () => { },
  } = props;
  const classes = TPaquetesStyle();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return (
                  <Row
                    key={row.IdPaquete}
                    row={row}
                    onEditar={onEditar}
                    onVuelos={onVuelos}
                    onExtras={onExtras}
                    onHotel={onHotel}
                    onHabitacion={onHabitacion}
                    onSalidas={onSalidas}
                    onGaleria={onGaleria}
                    onDestinos={onDestinos}
                  />
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
